export var FETCH_MAILS_REQUEST = 'FETCH_MAILS_REQUEST';
export var FETCH_MAILS_SUCCEEDED = 'FETCH_MAILS_SUCCEEDED';
export var FETCH_MAILS_FAILED = 'FETCH_MAILS_FAILED';
export var VALIDATE_MAIL_REQUEST = 'VALIDATE_MAIL_REQUEST';
export var VALIDATE_MAIL_SUCCEEDED = 'VALIDATE_MAIL_SUCCEEDED';
export var VALIDATE_MAIL_FAILED = 'VALIDATE_MAIL_FAILED';
export var VALIDATE_MODIFIED_MAIL_SUCCEEDED = 'VALIDATE_MODIFIED_MAIL_SUCCEEDED';
